module.exports = __webpack_public_path__ + "static/media/how-paid-search.e702f268.png";